export const Pipeline = Object.freeze({
  HYDRA: {
    label: "Hydra Revoked",
    key: "hydra",
  },
  HBBTV: {
    label: "HbbTv Revoked",
    key: "hbbTv",
  },
  APOLLO: {
    label: "Apollo Revoked",
    key: "apollo",
  },
});
